import React, { useEffect, useState } from 'react';


type Props = {
    run: () => void
    time: number
    check: boolean
}

export function RunAfterTimer({ run, time, check }: Props) {
    const [state] = useState<{
        checkValue: boolean
        activeTimerHandle: NodeJS.Timeout | null
    }>({ checkValue: check, activeTimerHandle: null })

    useEffect(() => {
        function cancelTimer() {
            if (state.activeTimerHandle !== null && state.activeTimerHandle !== undefined) {
                clearTimeout(state.activeTimerHandle)
                state.activeTimerHandle = null
            }
        }
        state.checkValue = check
        cancelTimer()
        if (check) {
            state.activeTimerHandle = setTimeout(() => {
                if (state.checkValue) {
                    run()
                }
            }, time)

        }
        return () => {
            cancelTimer()
        }
    }, [state, check, run, time])

    return <></>
}
